export const translations = {
  nav_dashboard: { en: "Dashboard", ru: "Дашборд", pl: "Pulpit" },
  nav_statistic: { en: "Statistic", ru: "Статистика", pl: "Statystyka" },
  nav_clients: { en: "Clients", ru: "Клиенты", pl: "Klienci" },
  nav_accounts: { en: "Accounts", ru: "Аккаунты", pl: "Konta" },
  nav_mails: { en: "Mails", ru: "Письма", pl: "E-maile" },
  nav_archive: { en: "Archive", ru: "Архив", pl: "Archiwum" },
  nav_logs: { en: "Logs", ru: "Логи", pl: "Logi" },
  nav_documentation: { en: "Documentation", ru: "Документация", pl: "Dokumentacja" },
  nav_operators: { en: "Operators", ru: "Операторы", pl: "Operatorzy" },
  nav_users: { en: "Users", ru: "Пользователи", pl: "Użytkownicy" },
  nav_dumps: { en: "Dumps", ru: "Дампы", pl: "Dumpy" },
  nav_site_visitors: { en: "Site visitors", ru: "Посетители сайта", pl: "Odwiedzający stronę" },
  nav_activity: { en: "Worker activity", ru: "Активность", pl: "Aktywność" },
  nav_admin: { en: "Admin", ru: "Админ", pl: "Admin" },

  search_records: { en: "Search records...", ru: "Поиск записей...", pl: "Szukaj rekordów..." },
  search_accounts: { en: "Search accounts...", ru: "Поиск аккаунтов...", pl: "Szukaj kont..." },
  search_clients: { en: "Search clients...", ru: "Поиск клиентов...", pl: "Szukaj klientów..." },
  search_archive: { en: "Search archive...", ru: "Поиск в архиве...", pl: "Szukaj w archiwum..." },
  search_logs: { en: "Search logs...", ru: "Поиск в логах...", pl: "Szukaj w logach..." },

  btn_add_record: { en: "Add Record", ru: "Добавить запись", pl: "Dodaj rekord" },
  btn_hide_sensitive: {
    en: "Hide sensitive",
    ru: "Скрыть данные",
    pl: "Ukryj dane",
  },
  btn_show_sensitive: {
    en: "Show sensitive",
    ru: "Показать данные",
    pl: "Pokaż dane",
  },
  btn_add_user: { en: "Add User", ru: "Добавить пользователя", pl: "Dodaj użytkownika" },

  btn_save: { en: "Save", ru: "Сохранить", pl: "Zapisz" },
  btn_cancel: { en: "Cancel", ru: "Отмена", pl: "Anuluj" },
  btn_create_ai_mail: { en: "Generate Mail", ru: "Создать AI письмо", pl: "Generuj e-mail" },
  btn_generate: { en: "Generate", ru: "Сгенерировать", pl: "Generuj" },
  btn_close: { en: "Close", ru: "Закрыть", pl: "Zamknij" },
  btn_delete: { en: "Delete", ru: "Удалить", pl: "Usuń" },
  btn_logout: { en: "Logout", ru: "Выйти", pl: "Wyloguj się" },
  btn_copy: { en: "Copy to clipboard", ru: "Копировать", pl: "Kopiuj do schowka" },
  btn_reveal_password: { en: "Reveal password", ru: "Показать пароль", pl: "Pokaż hasło" },
  btn_hide_password: { en: "Hide password", ru: "Скрыть пароль", pl: "Ukryj hasło" },
  btn_copy_password: { en: "Copy password", ru: "Копировать пароль", pl: "Kopiuj hasło" },
  btn_generate_secret_code: { en: "Generate code", ru: "Создать код", pl: "Generuj kod" },
  btn_reset_secret_code: { en: "Reset code", ru: "Сбросить код", pl: "Zresetuj kod" },
  btn_open: { en: "Open", ru: "Открыть", pl: "Otwórz" },
  btn_generate_profiles: {
    en: "Generate Profiles",
    ru: "Генерировать профили",
    pl: "Generuj profile",
  },
  btn_select_all: { en: "Select All", ru: "Выбрать все", pl: "Zaznacz wszystkie" },
  btn_deselect_all: { en: "Deselect All", ru: "Снять выбор", pl: "Odznacz wszystkie" },
  btn_sync_clients: {
    en: "Sync Clients",
    ru: "Синхронизировать клиентов",
    pl: "Synchronizuj klientów",
  },
  btn_delete_all: { en: "Delete All", ru: "Удалить все", pl: "Usuń wszystko" },
  dialog_confirm_delete_all: {
    en: "Are you sure you want to delete all profiles?",
    ru: "Вы уверены, что хотите удалить все профили?",
    pl: "Czy na pewno chcesz usunąć wszystkie profile?",
  },

  dialog_add_dashboard: {
    en: "Add Dashboard Record",
    ru: "Добавить запись",
    pl: "Dodaj rekord pulpitu",
  },
  dialog_edit_dashboard: {
    en: "Edit Dashboard Record",
    ru: "Редактировать запись",
    pl: "Edytuj rekord pulpitu",
  },
  dialog_add_account: { en: "Add Account", ru: "Добавить аккаунт", pl: "Dodaj konto" },
  dialog_edit_account: { en: "Edit Account", ru: "Редактировать аккаунт", pl: "Edytuj konto" },
  dialog_reveal_password: {
    en: "Reveal account password",
    ru: "Показать пароль аккаунта",
    pl: "Pokaż hasło konta",
  },
  password_not_set: { en: "Not set", ru: "Не задан", pl: "Nieustawione" },
  secret_code_title: {
    en: "Operator secret code",
    ru: "Секретный код оператора",
    pl: "Tajny kod operatora",
  },
  secret_code_copy_warning: {
    en: "Copy this code now. It will not be shown again.",
    ru: "Скопируйте код сейчас. Повторно он не будет показан.",
    pl: "Skopiuj kod teraz. Nie zostanie ponownie pokazany.",
  },
  secret_code_active: { en: "Code active", ru: "Код активен", pl: "Kod aktywny" },
  secret_code_missing: { en: "No code", ru: "Код не создан", pl: "Brak kodu" },
  confirm_reset_secret_code: {
    en: "Reset this operator's code? The old code will stop working immediately.",
    ru: "Сбросить код оператора? Старый код перестанет работать сразу.",
    pl: "Zresetować kod operatora? Stary kod natychmiast przestanie działać.",
  },
  dialog_add_client: { en: "Add Client", ru: "Добавить клиента", pl: "Dodaj klienta" },
  dialog_edit_client: { en: "Edit Client", ru: "Редактировать клиента", pl: "Edytuj klienta" },
  dialog_add_mail: { en: "Add Mail Record", ru: "Добавить запись", pl: "Dodaj e-mail" },
  dialog_edit_mail: { en: "Edit Mail Record", ru: "Редактировать запись", pl: "Edytuj e-mail" },
  dialog_ai_mail: { en: "Generate Mail", ru: "Создать AI письмо", pl: "Generuj e-mail" },
  dialog_record_mail: { en: "Record Mail", ru: "Записать письмо", pl: "Zapisz e-mail" },
  form_mail_type: { en: "Mail Type", ru: "Тип письма", pl: "Typ e-maila" },
  btn_record: { en: "Record", ru: "Записать", pl: "Zapisz" },
  toast_mail_recorded: { en: "Mail recorded", ru: "Письмо записано", pl: "E-mail zapisany" },

  dialog_generate_profiles: {
    en: "AI Search Profiles",
    ru: "AI Профили поиска",
    pl: "Profile wyszukiwania AI",
  },

  tip_generate_profiles: {
    en: "Generate Suchprofile",
    ru: "Генерировать Suchprofile",
    pl: "Generuj Suchprofile",
  },
  tip_personal_data: { en: "Personal Data", ru: "Личные данные", pl: "Dane osobowe" },
  dialog_personal_data: { en: "Personal Data", ru: "Личные данные", pl: "Dane osobowe" },

  label_max_rent: { en: "Max Rent (€)", ru: "Макс. аренда (€)", pl: "Maks. czynsz (€)" },
  label_min_rooms: { en: "Min Rooms", ru: "Мин. комнат", pl: "Min. pokoi" },
  label_max_rooms: { en: "Max Rooms", ru: "Макс. комнат", pl: "Maks. pokoi" },
  label_size: { en: "Size (m²)", ru: "Площадь (м²)", pl: "Powierzchnia (m²)" },
  generating_profiles: {
    en: "Generating profiles...",
    ru: "Генерация профилей...",
    pl: "Generowanie profili...",
  },
  no_comment_warning: {
    en: "No comment found. Generation will be based on basic client data.",
    ru: "Комментарий не найден. Генерация будет на основе базовых данных клиента.",
    pl: "Nie znaleziono komentarza. Generowanie będzie oparte na podstawowych danych klienta.",
  },

  th_alive: { en: "Alive", ru: "Время жизни", pl: "Czas życia" },
  th_date: { en: "Termin Date", ru: "Дата просмотра", pl: "Data oglądania" },
  th_chart: { en: "Chart", ru: "График", pl: "Wykres" },
  th_time: { en: "Time", ru: "Время", pl: "Czas" },
  th_client: { en: "Client", ru: "Клиент", pl: "Klient" },
  th_account: { en: "Account", ru: "Аккаунт", pl: "Konto" },
  th_strategy: { en: "Strategy", ru: "Стратегия", pl: "Strategia" },
  th_object_id: { en: "Object ID", ru: "ID объекта", pl: "ID obiektu" },
  th_object_link: { en: "Object Link", ru: "Ссылка", pl: "Link do obiektu" },
  th_status: { en: "Status", ru: "Статус", pl: "Status" },
  th_added: { en: "Added", ru: "Добавлен", pl: "Dodano" },
  th_mails: { en: "Mails", ru: "Письма", pl: "E-maile" },
  th_origin: { en: "Origin", ru: "Источник", pl: "Źródło" },
  th_cooperative: { en: "Cooperative", ru: "Кооператив", pl: "Spółdzielnia" },
  th_comment: { en: "Comment", ru: "Комментарий", pl: "Komentarz" },
  th_termin_date: { en: "Termin Date", ru: "Дата просмотра", pl: "Data oglądania" },
  th_archived_at: { en: "Archived At", ru: "Дата архивации", pl: "Data archiwizacji" },
  th_archived_by: { en: "Archived By", ru: "Архивирован", pl: "Archiwizowane przez" },
  th_actions: { en: "Actions", ru: "Действия", pl: "Akcje" },
  th_account_id: { en: "ID", ru: "ID", pl: "ID" },
  th_email: { en: "Email", ru: "Email", pl: "E-mail" },
  th_password: { en: "Password", ru: "Пароль", pl: "Hasło" },
  th_role: { en: "Role", ru: "Роль", pl: "Rola" },
  th_creation_date: { en: "Creation Date", ru: "Дата создания", pl: "Data utworzenia" },
  th_last_activity: { en: "Last activity", ru: "Последняя активность", pl: "Ostatnia aktywność" },
  th_sms_verified: { en: "SMS Verified", ru: "SMS подтверждён", pl: "SMS zweryfikowany" },
  th_proxy: { en: "Proxy", ru: "Прокси", pl: "Proxy" },
  sms_verified_ok: { en: "SMS verified", ru: "SMS подтверждён", pl: "SMS zweryfikowany" },
  sms_verify_needed: {
    en: "SMS verification required",
    ru: "Требуется подтверждение по SMS",
    pl: "Wymagana weryfikacja SMS",
  },

  th_link_on_site: { en: "Link on Site", ru: "Ссылка на сайте", pl: "Link na stronie" },
  th_id: { en: "ID", ru: "ID", pl: "ID" },
  th_full_name: { en: "Full Name", ru: "ФИО", pl: "Imię i nazwisko" },
  th_phone: { en: "Phone", ru: "Телефон", pl: "Telefon" },
  th_folder_link: { en: "Folder Link", ru: "Ссылка на папку", pl: "Link do folderu" },
  th_operator: { en: "Operator", ru: "Оператор", pl: "Operator" },
  th_user: { en: "User", ru: "Пользователь", pl: "Użytkownik" },
  th_price: { en: "Price", ru: "Цена", pl: "Cena" },
  th_rooms: { en: "Rooms", ru: "Комнаты", pl: "Pokoje" },
  th_sqft: { en: "Sqft", ru: "Площадь", pl: "Powierzchnia" },
  th_location: { en: "Location", ru: "Локация", pl: "Lokalizacja" },
  th_documents: { en: "Documents", ru: "Документы", pl: "Dokumenty" },
  th_partnership: { en: "Added", ru: "Сотрудничество", pl: "Współpraca" },
  th_subscription: { en: "Subscription", ru: "Подписка", pl: "Subskrypcja" },
  th_subscription_start: {
    en: "Subscription Start",
    ru: "Начало подписки",
    pl: "Początek subskrypcji",
  },
  th_subscription_end: { en: "Subscription End", ru: "Окончание", pl: "Koniec subskrypcji" },
  form_subscription_start: { en: "Start Date", ru: "Дата начала", pl: "Data rozpoczęcia" },
  form_subscription_end: { en: "End Date", ru: "Дата окончания", pl: "Data zakończenia" },
  th_gratitude: { en: "Gratitude", ru: "Благодарность", pl: "Podziękowanie" },
  th_motivation: { en: "Motivation", ru: "Мотивация", pl: "Motywacja" },
  th_feedback: { en: "Feedback", ru: "Отзыв", pl: "Opinia" },
  th_after_review: { en: "After Review", ru: "После осмотра", pl: "Po oglądaniu" },
  th_termin: { en: "Termin", ru: "Термин", pl: "Termin" },
  th_agent: { en: "Agent", ru: "Агент", pl: "Agent" },
  th_template: { en: "Template", ru: "Шаблон", pl: "Szablon" },
  th_page: { en: "Page", ru: "Страница", pl: "Strona" },
  th_action: { en: "Action", ru: "Действие", pl: "Akcja" },
  th_client_id: { en: "Client ID", ru: "ID клиента", pl: "ID klienta" },
  th_account_email: { en: "Account", ru: "Аккаунт", pl: "Konto" },
  th_details: { en: "Details", ru: "Детали", pl: "Szczegóły" },

  form_object_id: { en: "Object ID", ru: "ID объекта", pl: "ID obiektu" },
  form_object_link: { en: "Object Link", ru: "Ссылка на объект", pl: "Link do obiektu" },
  form_strategy: { en: "Strategy", ru: "Стратегия", pl: "Strategia" },
  form_account: { en: "Account", ru: "Аккаунт", pl: "Konto" },
  form_status: { en: "Status", ru: "Статус", pl: "Status" },
  form_comment: { en: "Comment", ru: "Комментарий", pl: "Komentarz" },
  form_cooperative: { en: "Cooperative", ru: "Кооператив", pl: "Spółdzielnia" },
  form_sent_mails: { en: "Sent Mails", ru: "Отправленные письма", pl: "Wysłane e-maile" },
  form_title: { en: "Title", ru: "Название", pl: "Tytuł" },
  form_account_id: { en: "Account ID", ru: "ID аккаунта", pl: "ID konta" },
  form_client: { en: "Client", ru: "Клиент", pl: "Klient" },
  form_email: { en: "Email", ru: "Email", pl: "E-mail" },
  form_account_password: { en: "Account password", ru: "Пароль аккаунта", pl: "Hasło konta" },
  form_account_password_optional: {
    en: "Optional; leave blank if not set",
    ru: "Необязательно; оставьте пустым, если нет",
    pl: "Opcjonalne; pozostaw puste, jeśli nie ustawiono",
  },
  form_account_password_keep: {
    en: "Leave blank to keep the current password",
    ru: "Оставьте пустым, чтобы сохранить текущий пароль",
    pl: "Pozostaw puste, aby zachować obecne hasło",
  },
  form_secret_code: { en: "Secret code", ru: "Секретный код", pl: "Tajny kod" },
  form_secret_code_hint: {
    en: "Ask the administrator for your personal code.",
    ru: "Спросите у администратора ваш личный код.",
    pl: "Poproś administratora o swój osobisty kod.",
  },
  form_link_on_site: { en: "Link on Site", ru: "Ссылка на сайте", pl: "Link na stronie" },
  form_full_name: { en: "Full Name", ru: "ФИО", pl: "Imię i nazwisko" },
  form_phone: { en: "Phone", ru: "Телефон", pl: "Telefon" },
  form_folder_link: { en: "Folder Link", ru: "Ссылка на папку", pl: "Link do folderu" },
  form_operator: { en: "Operator", ru: "Оператор", pl: "Operator" },
  form_price: { en: "Price", ru: "Цена", pl: "Cena" },
  form_rooms: { en: "Rooms", ru: "Комнаты", pl: "Pokoje" },
  form_sqft: { en: "Sqft", ru: "Площадь", pl: "Powierzchnia" },
  form_location: { en: "Location", ru: "Локация", pl: "Lokalizacja" },
  form_documents: { en: "Documents", ru: "Документы", pl: "Dokumenty" },
  form_termin_date: { en: "Termin Date", ru: "Дата просмотра", pl: "Data oglądania" },
  form_instructions: { en: "Instructions", ru: "Инструкции", pl: "Instrukcje" },
  form_agent: { en: "Agent", ru: "Агент", pl: "Agent" },
  toggle_know_agent: { en: "I know agent name", ru: "Знаю имя агента", pl: "Znam nazwisko agenta" },
  form_ai_german: { en: "AI German", ru: "AI Немецкий", pl: "AI niemiecki" },
  form_ai_ukrainian: { en: "AI Ukrainian", ru: "AI Украинский", pl: "AI ukraiński" },
  form_notes: { en: "Notes", ru: "Заметки", pl: "Notatki" },
  form_color: { en: "Color", ru: "Цвет", pl: "Kolor" },
  form_password: { en: "Password", ru: "Пароль", pl: "Hasło" },
  form_sex: { en: "Sex (Geschlecht)", ru: "Пол (Geschlecht)", pl: "Płeć (Geschlecht)" },
  form_birth_name: {
    en: "Last Name at Birth (Geburtsname)",
    ru: "Фамилия при рождении (Geburtsname)",
    pl: "Nazwisko rodowe (Geburtsname)",
  },
  form_birth_place_city: {
    en: "Birth Place City (Geburtsort)",
    ru: "Место рождения, город (Geburtsort)",
    pl: "Miejsce urodzenia, miasto (Geburtsort)",
  },
  form_birth_place_country: {
    en: "Birth Place Country (Geburtsland)",
    ru: "Место рождения, страна (Geburtsland)",
    pl: "Miejsce urodzenia, kraj (Geburtsland)",
  },
  form_street: { en: "Street (Straße)", ru: "Улица (Straße)", pl: "Ulica (Straße)" },
  form_house_number: {
    en: "House Number (Hausnummer)",
    ru: "Номер дома (Hausnummer)",
    pl: "Numer domu (Hausnummer)",
  },
  form_plz: { en: "PLZ (Postleitzahl)", ru: "ПЛЗ (Postleitzahl)", pl: "PLZ (Postleitzahl)" },
  form_city: { en: "City (Ort)", ru: "Город (Ort)", pl: "Miasto (Ort)" },
  form_country: { en: "Country (Land)", ru: "Страна (Land)", pl: "Kraj (Land)" },
  form_additional_tenant_info: {
    en: "Persönliche Informationen weiterer Mitmieter/in (weitere Vertragspartner)",
    ru: "Личная информация дополнительного арендатора (дополнительный контрактный партнер)",
    pl: "Informacje o pozostałych współnajemcach (pozostałych stronach umowy)",
  },
  form_additional_adults: {
    en: "Werden weitere Personen über 18 Jahre im Haushalt wohnen (keine weiteren Vertragspartner)?",
    ru: "Будут ли проживать другие лица старше 18 лет (не дополнительные контрактные партнеры)?",
    pl: "Czy w gospodarstwie domowym będą mieszkać inne osoby pełnoletnie (niebędące stronami umowy)?",
  },
  form_additional_minors: {
    en: "Werden weitere Personen unter 18 Jahre im Haushalt wohnen?",
    ru: "Будут ли проживать другие лица младше 18 лет?",
    pl: "Czy w gospodarstwie domowym będą mieszkać osoby poniżej 18 lat?",
  },
  form_enabled: {
    en: "Client Enabled",
    ru: "Клиент активен",
    pl: "Klient aktywny",
  },
  form_disabled_reason: {
    en: "Reason for disabling",
    ru: "Причина отключения",
    pl: "Powód wyłączenia",
  },
  reason_package_ended: {
    en: "Package ended",
    ru: "Пакет завершён",
    pl: "Pakiet zakończony",
  },
  reason_client_decision: {
    en: "Client decision",
    ru: "Решение клиента",
    pl: "Decyzja klienta",
  },
  reason_settled: {
    en: "Settled",
    ru: "Устроен",
    pl: "Załatwione",
  },
  reason_other: {
    en: "Other",
    ru: "Другое",
    pl: "Inne",
  },
  err_disabled_reason_required: {
    en: "Please select a reason for disabling this client.",
    ru: "Пожалуйста, выберите причину отключения клиента.",
    pl: "Wybierz powód wyłączenia tego klienta.",
  },
  th_reason: {
    en: "Reason",
    ru: "Причина",
    pl: "Powód",
  },
  th_disabled_clients: {
    en: "Disabled Clients",
    ru: "Отключённые клиенты",
    pl: "Wyłączeni klienci",
  },
  btn_enable: {
    en: "Enable",
    ru: "Включить",
    pl: "Włącz",
  },
  tip_enable: {
    en: "Re-enable client",
    ru: "Включить клиента",
    pl: "Włącz klienta",
  },
  btn_disable: {
    en: "Disable",
    ru: "Отключить",
    pl: "Wyłącz",
  },
  confirm_disable_user: {
    en: "Disable this user? They will be logged out immediately and blocked from logging in.",
    ru: "Отключить этого пользователя? Он будет немедленно разлогинен и не сможет войти.",
    pl: "Wyłączyć tego użytkownika? Zostanie natychmiast wylogowany i nie będzie mógł się zalogować.",
  },
  form_additional_persons_adult: {
    en: "Personen über 18",
    ru: "Лица старше 18 лет",
    pl: "Osoby powyżej 18 lat",
  },
  form_additional_persons_minor: {
    en: "Personen unter 18",
    ru: "Лица младше 18 лет",
    pl: "Osoby poniżej 18 lat",
  },
  form_additional_persons_co_tenant: {
    en: "Weitere Mieter/innen (Vertragspartner)",
    ru: "Дополнительные арендаторы (контрактные партнеры)",
    pl: "Dodatkowi najemcy (partnerzy umowni)",
  },
  form_salutation: {
    en: "Anrede",
    ru: "Обращение",
    pl: "Tytył",
  },
  form_add_person: {
    en: "+ Person hinzufügen",
    ru: "+ Добавить лицо",
    pl: "+ Dodaj osobę",
  },
  form_first_name: {
    en: "Vorname",
    ru: "Имя",
    pl: "Imię",
  },
  form_last_name: {
    en: "Nachname",
    ru: "Фамилия",
    pl: "Nazwisko",
  },
  form_birthday: {
    en: "Geburtstag",
    ru: "Дата рождения",
    pl: "Data urodzenia",
  },
  form_profession: { en: "Profession (Beruf)", ru: "Профессия (Beruf)", pl: "Zawód (Beruf)" },
  form_employer: {
    en: "Employer (Arbeitgeber)",
    ru: "Работодатель (Arbeitgeber)",
    pl: "Pracodawca (Arbeitgeber)",
  },
  form_monthly_net_income: {
    en: "Monthly Net Income (€)",
    ru: "Ежемесячный чистый доход (Monatliches Nettoeinkommen) (€)",
    pl: "Miesięczny dochód netto (€)",
  },
  sex_male: { en: "Male", ru: "Мужской", pl: "Mężczyzna" },
  sex_female: { en: "Female", ru: "Женский", pl: "Kobieta" },

  placeholder_select_strategy: {
    en: "Select strategy",
    ru: "Выберите стратегию",
    pl: "Wybierz strategię",
  },
  placeholder_select_account: { en: "Select account", ru: "Выберите аккаунт", pl: "Wybierz konto" },
  form_proxy: { en: "Proxy", ru: "Прокси", pl: "Proxy" },
  placeholder_select_proxy: { en: "No proxy", ru: "Без прокси", pl: "Bez proxy" },
  form_proxy_hint: {
    en: "No proxies available yet",
    ru: "Прокси пока не добавлены",
    pl: "Brak dostępnych proxy",
  },
  placeholder_select_status: { en: "Select status", ru: "Выберите статус", pl: "Wybierz status" },
  placeholder_add_comment: {
    en: "Add a comment...",
    ru: "Добавьте комментарий...",
    pl: "Dodaj komentarz...",
  },
  placeholder_client_name: { en: "Client name", ru: "Имя клиента", pl: "Imię klienta" },
  placeholder_drive: {
    en: "https://drive.google.com/...",
    ru: "https://drive.google.com/...",
    pl: "https://drive.google.com/...",
  },
  placeholder_price: { en: "e.g. under 1000$", ru: "напр. до 1000$", pl: "np. do 1000$" },
  placeholder_rooms: { en: "e.g. 2", ru: "напр. 2", pl: "np. 2" },
  placeholder_sqft: { en: "e.g. 1000 sqft", ru: "напр. 1000 кв.фт", pl: "np. 1000 sqft" },
  placeholder_instructions: {
    en: "Additional context or instructions for the mail...",
    ru: "Дополнительный контекст или инструкции для письма...",
    pl: "Dodatkowy kontekst lub instrukcje dla e-maila...",
  },
  placeholder_agent: { en: "Agent name", ru: "Имя агента", pl: "Nazwisko agenta" },
  placeholder_ai_german: {
    en: "German AI result...",
    ru: "Результат AI на немецком...",
    pl: "Wynik AI po niemiecku...",
  },
  placeholder_ai_ukrainian: {
    en: "Ukrainian AI result...",
    ru: "Результат AI на украинском...",
    pl: "Wynik AI po ukraińsku...",
  },
  placeholder_notes: {
    en: "Additional notes...",
    ru: "Дополнительные заметки...",
    pl: "Dodatkowe notatki...",
  },

  status_request_submitted: {
    en: "Request submitted",
    ru: "Запрос отправлен",
    pl: "Wniosek wysłany",
  },
  status_termin_invitation: {
    en: "Termin invitation",
    ru: "Приглашение на просмотр",
    pl: "Zaproszenie na oglądanie",
  },
  status_waiting: { en: "Waiting", ru: "Ожидание", pl: "Oczekiwanie" },
  status_completed: { en: "Completed", ru: "Завершено", pl: "Zakończone" },
  status_no_relevant: { en: "No relevant", ru: "Не актуально", pl: "Nieaktualne" },
  status_denied: { en: "Denied", ru: "Отказано", pl: "Odrzucone" },
  status_absage: { en: "Absage", ru: "Отказ", pl: "Odmowa" },
  status_error: { en: "Error", ru: "Ошибка", pl: "Błąd" },
  status_active: { en: "ACTIVE", ru: "АКТИВЕН", pl: "AKTYWNY" },
  status_not_used: { en: "NOT USED", ru: "НЕ ИСПОЛЬЗУЕТСЯ", pl: "NIEWYKORZYSTANY" },

  status_blocked: { en: "BLOCKED", ru: "ЗАБЛОКИРОВАН", pl: "ZABLOKOWANY" },
  status_archive: { en: "ARCHIVE", ru: "АРХИВ", pl: "ARCHIWUM" },

  strategy_active: { en: "Active", ru: "Активный", pl: "Aktywna" },
  strategy_outsource: { en: "Outsource", ru: "Аутсорс", pl: "Outsourcing" },
  strategy_passive_1: { en: "Passive 1", ru: "Пассив 1", pl: "Pasywna 1" },
  strategy_passive_2: { en: "Passive 2", ru: "Пассив 2", pl: "Pasywna 2" },
  strategy_passive_3: { en: "Passive 3", ru: "Пассив 3", pl: "Pasywna 3" },
  strategy_passive_4: { en: "Passive 4", ru: "Пассив 4", pl: "Pasywna 4" },
  strategy_passive_5: { en: "Passive 5", ru: "Пассив 5", pl: "Pasywna 5" },

  role_admin: { en: "Admin", ru: "Администратор", pl: "Administrator" },
  role_operator: { en: "Operator", ru: "Оператор", pl: "Operator" },

  users_count: { en: "{0} users", ru: "{0} пользователей", pl: "{0} użytkowników" },
  accounts_archived: {
    en: "Archived Accounts",
    ru: "Архивные аккаунты",
    pl: "Zarchiwizowane konta",
  },
  accounts_archived_count: {
    en: "{0} archived accounts",
    ru: "{0} архивных аккаунтов",
    pl: "{0} zarchiwizowanych kont",
  },
  th_clients: { en: "Clients", ru: "Клиенты", pl: "Klienci" },
  th_accounts: { en: "Accounts", ru: "Аккаунты", pl: "Konta" },
  btn_view_clients: {
    en: "Clients & accounts",
    ru: "Клиенты и аккаунты",
    pl: "Klienci i konta",
  },
  user_clients_summary: {
    en: "{0} clients · {1} accounts",
    ru: "{0} клиентов · {1} аккаунтов",
    pl: "{0} klientów · {1} kont",
  },
  user_clients_empty: {
    en: "No clients assigned to this user",
    ru: "За этим пользователем не закреплено клиентов",
    pl: "Brak klientów przypisanych do tego użytkownika",
  },
  loading: { en: "Loading...", ru: "Загрузка...", pl: "Ładowanie..." },
  no_data: { en: "No data", ru: "Нет данных", pl: "Brak danych" },
  pagination_prev: { en: "Previous", ru: "Назад", pl: "Poprzednia" },
  pagination_next: { en: "Next", ru: "Вперёд", pl: "Następna" },
  pagination_page: {
    en: "Page {0} of {1}",
    ru: "Страница {0} из {1}",
    pl: "Strona {0} z {1}",
  },
  pagination_summary: {
    en: "{0}–{1} of {2}",
    ru: "{0}–{1} из {2}",
    pl: "{0}–{1} z {2}",
  },

  visitors_today: { en: "Today", ru: "Сегодня", pl: "Dziś" },
  visitors_yesterday: { en: "Yesterday", ru: "Вчера", pl: "Wczoraj" },
  visitors_last_7_days: { en: "Last 7 days", ru: "За 7 дней", pl: "Ostatnie 7 dni" },
  visitors_last_30_days: { en: "Last 30 days", ru: "За 30 дней", pl: "Ostatnie 30 dni" },
  visitors_unique: {
    en: "Unique visitors",
    ru: "Уникальные посетители",
    pl: "Unikalni odwiedzający",
  },
  visitors_visits: { en: "Visits", ru: "Визиты", pl: "Wizyty" },
  visitors_daily: { en: "Daily visitors", ru: "Посетители по дням", pl: "Odwiedzający według dni" },
  visitors_empty: {
    en: "No visits recorded yet",
    ru: "Визиты ещё не зафиксированы",
    pl: "Brak zarejestrowanych wizyt",
  },

  statistic_title: {
    en: "Termin statistics",
    ru: "Статистика терминов",
    pl: "Statystyka terminów",
  },
  statistic_subtitle: {
    en: "Termin analytics by client",
    ru: "Аналитика терминов по клиентам",
    pl: "Analiza terminów według klientów",
  },
  statistic_period_week: { en: "Last week", ru: "За неделю", pl: "Ostatni tydzień" },
  statistic_period_month: { en: "Last month", ru: "За месяц", pl: "Ostatni miesiąc" },
  statistic_period_quarter: {
    en: "Last 3 months",
    ru: "За 3 месяца",
    pl: "Ostatnie 3 miesiące",
  },
  statistic_range: {
    en: "{0} – {1}",
    ru: "{0} – {1}",
    pl: "{0} – {1}",
  },
  statistic_total_termins: { en: "Termins", ru: "Термины", pl: "Terminy" },
  statistic_termins: { en: "Termins", ru: "Термины", pl: "Terminy" },
  statistic_clients: {
    en: "Clients with termins",
    ru: "Клиенты с терминами",
    pl: "Klienci z terminami",
  },
  statistic_completed: { en: "Completed", ru: "Завершено", pl: "Zakończone" },
  statistic_cancelled: { en: "Cancelled", ru: "Отменено", pl: "Odwołane" },
  statistic_open: { en: "Open", ru: "Открыто", pl: "Otwarte" },
  statistic_share: { en: "Share", ru: "Доля", pl: "Udział" },
  statistic_last_termin: {
    en: "Last Termin",
    ru: "Последний термин",
    pl: "Ostatni termin",
  },
  statistic_top_clients: {
    en: "Top clients by termins",
    ru: "Топ клиентов по терминам",
    pl: "Najlepsi klienci według terminów",
  },
  statistic_by_client: {
    en: "Termins by client",
    ru: "Термины по клиентам",
    pl: "Terminy według klientów",
  },
  statistic_empty: {
    en: "No termins in the selected period",
    ru: "За выбранный период терминов нет",
    pl: "Brak terminów w wybranym okresie",
  },

  nav_bot: { en: "Bot", ru: "Бот", pl: "Bot" },

  bot_title: { en: "Telegram Bot", ru: "Telegram-бот", pl: "Bot Telegram" },
  bot_subtitle: {
    en: "Termin reminders, client chats and scheduled messages",
    ru: "Напоминания о терминах, чаты клиентов и отложенные сообщения",
    pl: "Przypomnienia o terminach, czaty klientów i zaplanowane wiadomości",
  },
  bot_source_env: {
    en: "Using environment fallback",
    ru: "Используются настройки окружения",
    pl: "Używane ustawienia środowiska",
  },
  bot_source_database: {
    en: "Saved settings",
    ru: "Сохранённые настройки",
    pl: "Zapisane ustawienia",
  },
  bot_bot_missing: {
    en: "Reminder bot token is not configured (TELEGRAM_BOT_TOKEN).",
    ru: "Токен бота для напоминаний не настроен (TELEGRAM_BOT_TOKEN).",
    pl: "Token bota przypomnień nie jest skonfigurowany (TELEGRAM_BOT_TOKEN).",
  },
  bot_bot_ready: {
    en: "Reminder bot is configured",
    ru: "Бот для напоминаний настроен",
    pl: "Bot przypomnień jest skonfigurowany",
  },
  bot_timezone: {
    en: "Time zone: {0}",
    ru: "Часовой пояс: {0}",
    pl: "Strefa czasowa: {0}",
  },
  bot_updated: {
    en: "Updated: {0}",
    ru: "Обновлено: {0}",
    pl: "Zaktualizowano: {0}",
  },
  bot_termin_reminders: {
    en: "Termin reminders",
    ru: "Напоминания о терминах",
    pl: "Przypomnienia o terminach",
  },
  bot_termin_reminders_desc: {
    en: "Choose how long before and after a Termin the bot should send a message.",
    ru: "Выберите, за сколько до и через сколько после термина бот должен отправить сообщение.",
    pl: "Wybierz, ile przed i po terminie bot ma wysłać wiadomość.",
  },
  bot_enabled: {
    en: "Send Termin reminders",
    ru: "Отправлять напоминания о терминах",
    pl: "Wysyłaj przypomnienia o terminach",
  },
  bot_before: { en: "Before Termin", ru: "До термина", pl: "Przed terminem" },
  bot_after: { en: "After Termin", ru: "После термина", pl: "Po terminie" },
  bot_before_desc: {
    en: "Reminders sent before the Termin starts.",
    ru: "Напоминания, отправленные до начала термина.",
    pl: "Przypomnienia wysyłane przed rozpoczęciem terminu.",
  },
  bot_after_desc: {
    en: "Follow-ups sent after the Termin starts.",
    ru: "Сообщения, отправленные после начала термина.",
    pl: "Wiadomości wysyłane po rozpoczęciu terminu.",
  },
  bot_add_offset: { en: "Add offset", ru: "Добавить интервал", pl: "Dodaj odstęp" },
  bot_minutes: { en: "min", ru: "мин", pl: "min" },
  bot_hours: { en: "hr", ru: "ч", pl: "godz." },
  bot_destination: { en: "Destination", ru: "Получатель", pl: "Odbiorca" },
  bot_destination_client: {
    en: "Client chats",
    ru: "Чаты клиентов",
    pl: "Czaty klientów",
  },
  bot_destination_central: {
    en: "Central chat",
    ru: "Центральный чат",
    pl: "Czat centralny",
  },
  bot_destination_client_desc: {
    en: "Each reminder goes to the client's own Telegram chat.",
    ru: "Каждое напоминание отправляется в Telegram-чат клиента.",
    pl: "Każde przypomnienie trafia do czatu Telegram klienta.",
  },
  bot_destination_central_desc: {
    en: "All reminders go to one central chat or topic.",
    ru: "Все напоминания отправляются в один центральный чат или тему.",
    pl: "Wszystkie przypomnienia trafiają do jednego czatu lub wątku.",
  },
  bot_central_chat: {
    en: "Central chat ID",
    ru: "ID центрального чата",
    pl: "ID czatu centralnego",
  },
  bot_central_thread: {
    en: "Central thread ID",
    ru: "ID темы центрального чата",
    pl: "ID wątku czatu centralnego",
  },
  bot_central_hint: {
    en: "Leave empty to use the default TELEGRAM_CHAT_ID / TELEGRAM_THREAD_ID.",
    ru: "Оставьте пустым, чтобы использовать TELEGRAM_CHAT_ID / TELEGRAM_THREAD_ID по умолчанию.",
    pl: "Pozostaw puste, aby użyć domyślnych TELEGRAM_CHAT_ID / TELEGRAM_THREAD_ID.",
  },
  bot_save_settings: {
    en: "Save settings",
    ru: "Сохранить настройки",
    pl: "Zapisz ustawienia",
  },
  bot_offsets_required: {
    en: "Add at least one reminder offset.",
    ru: "Добавьте хотя бы один интервал напоминания.",
    pl: "Dodaj co najmniej jeden odstęp przypomnienia.",
  },
  bot_client_chats: {
    en: "Client Telegram chats",
    ru: "Telegram-чаты клиентов",
    pl: "Czaty Telegram klientów",
  },
  bot_client_chats_desc: {
    en: "The chat ID can be a group or channel. A topic/thread ID is optional.",
    ru: "ID чата может быть группой или каналом. ID темы указывать необязательно.",
    pl: "ID czatu może być grupą lub kanałem. ID wątku jest opcjonalne.",
  },
  bot_search_clients: {
    en: "Search clients...",
    ru: "Поиск клиентов...",
    pl: "Szukaj klientów...",
  },
  bot_client: { en: "Client", ru: "Клиент", pl: "Klient" },
  bot_chat_id: { en: "Chat ID", ru: "ID чата", pl: "ID czatu" },
  bot_thread_id: { en: "Thread ID", ru: "ID темы", pl: "ID wątku" },
  bot_chat_enabled: { en: "Enabled", ru: "Включено", pl: "Włączone" },
  bot_source: { en: "Source", ru: "Источник", pl: "Źródło" },
  bot_source_default: { en: "Default", ru: "По умолчанию", pl: "Domyślne" },
  bot_source_custom: { en: "Custom", ru: "Своё", pl: "Własne" },
  bot_source_none: { en: "Not set", ru: "Не задано", pl: "Nie ustawiono" },
  bot_test: { en: "Test", ru: "Тест", pl: "Test" },
  bot_no_chats: {
    en: "No clients found",
    ru: "Клиенты не найдены",
    pl: "Nie znaleziono klientów",
  },
  bot_no_client_chat: {
    en: "This client has no Telegram chat configured.",
    ru: "Для этого клиента не настроен Telegram-чат.",
    pl: "Ten klient nie ma skonfigurowanego czatu Telegram.",
  },
  bot_client_inactive: {
    en: "Inactive",
    ru: "Неактивен",
    pl: "Nieaktywny",
  },
  bot_scheduled: {
    en: "Scheduled messages",
    ru: "Отложенные сообщения",
    pl: "Zaplanowane wiadomości",
  },
  bot_scheduled_desc: {
    en: "Send a one-off message to a client chat at a chosen time.",
    ru: "Отправить разовое сообщение в чат клиента в выбранное время.",
    pl: "Wyślij jednorazową wiadomość do czatu klienta o wybranej porze.",
  },
  bot_target: { en: "Recipient", ru: "Получатель", pl: "Odbiorca" },
  bot_target_client: { en: "Client chat", ru: "Чат клиента", pl: "Czat klienta" },
  bot_target_custom: { en: "Custom chat ID", ru: "Свой ID чата", pl: "Własny ID czatu" },
  bot_message: { en: "Message", ru: "Сообщение", pl: "Wiadomość" },
  bot_send_at: { en: "Send at", ru: "Отправить в", pl: "Wyślij o" },
  bot_schedule: { en: "Schedule", ru: "Запланировать", pl: "Zaplanuj" },
  bot_scheduled_messages: {
    en: "Scheduled messages",
    ru: "Запланированные сообщения",
    pl: "Zaplanowane wiadomości",
  },
  bot_no_scheduled: {
    en: "No scheduled messages yet",
    ru: "Запланированных сообщений пока нет",
    pl: "Brak zaplanowanych wiadomości",
  },
  bot_status: { en: "Status", ru: "Статус", pl: "Status" },
  bot_status_pending: { en: "Pending", ru: "Ожидает", pl: "Oczekuje" },
  bot_status_sent: { en: "Sent", ru: "Отправлено", pl: "Wysłano" },
  bot_status_failed: { en: "Failed", ru: "Ошибка", pl: "Błąd" },
  bot_status_cancelled: { en: "Cancelled", ru: "Отменено", pl: "Anulowano" },
  bot_created_by: { en: "Created by", ru: "Создал", pl: "Utworzył" },
  bot_cancel: { en: "Cancel", ru: "Отменить", pl: "Anuluj" },
  bot_message_required: {
    en: "Enter a message.",
    ru: "Введите сообщение.",
    pl: "Wpisz wiadomość.",
  },
  bot_send_at_required: {
    en: "Choose a send date and time.",
    ru: "Выберите дату и время отправки.",
    pl: "Wybierz datę i godzinę wysyłki.",
  },
  bot_chat_required: {
    en: "Enter a chat ID.",
    ru: "Введите ID чата.",
    pl: "Wpisz ID czatu.",
  },
  bot_custom_chat: { en: "Chat ID", ru: "ID чата", pl: "ID czatu" },
  bot_client_placeholder: {
    en: "Choose a client",
    ru: "Выберите клиента",
    pl: "Wybierz klienta",
  },
  bot_chat_placeholder: {
    en: "e.g. -1001234567890",
    ru: "например, -1001234567890",
    pl: "np. -1001234567890",
  },
  bot_thread_placeholder: {
    en: "Optional topic/thread ID",
    ru: "ID темы (необязательно)",
    pl: "Opcjonalny ID wątku",
  },
  bot_message_placeholder: {
    en: "Message to send...",
    ru: "Сообщение для отправки...",
    pl: "Wiadomość do wysłania...",
  },
  bot_schedule_hint: {
    en: "The bot checks for due messages every minute.",
    ru: "Бот проверяет готовые к отправке сообщения каждую минуту.",
    pl: "Bot sprawdza wiadomości do wysłania co minutę.",
  },

  activity_online_now: { en: "Online now", ru: "Сейчас онлайн", pl: "Teraz online" },
  activity_offline: { en: "Offline", ru: "Офлайн", pl: "Offline" },
  activity_online: { en: "Online", ru: "Онлайн", pl: "Online" },
  activity_total_tabs: { en: "Open tabs", ru: "Открытые вкладки", pl: "Otwarte karty" },
  activity_today_window: {
    en: "Today's window",
    ru: "Окно сегодня",
    pl: "Dzisiejszy przedział",
  },
  activity_live: { en: "Live", ru: "Онлайн", pl: "Na żywo" },
  activity_history: { en: "Daily history", ru: "История по дням", pl: "Historia dzienna" },
  activity_worker: { en: "Worker", ru: "Сотрудник", pl: "Pracownik" },
  activity_status: { en: "Status", ru: "Статус", pl: "Status" },
  activity_tabs: { en: "Tabs", ru: "Вкладки", pl: "Karty" },
  activity_last_seen: { en: "Last seen", ru: "Последняя активность", pl: "Ostatnio widziany" },
  activity_session: { en: "Session", ru: "Сессия", pl: "Sesja" },
  activity_today: { en: "Today", ru: "Сегодня", pl: "Dzisiaj" },
  activity_date: { en: "Date", ru: "Дата", pl: "Data" },
  activity_work_window: {
    en: "Work window",
    ru: "Рабочее окно",
    pl: "Przedział pracy",
  },
  activity_heartbeats: { en: "Heartbeats", ru: "Сигналы", pl: "Sygnały" },
  activity_browsers: { en: "browsers", ru: "браузеры", pl: "przeglądarki" },
  activity_empty: {
    en: "No worker activity recorded yet",
    ru: "Активность сотрудников ещё не зафиксирована",
    pl: "Brak zarejestrowanej aktywności pracowników",
  },
  activity_never: { en: "never", ru: "никогда", pl: "nigdy" },

  activity_open_overview: {
    en: "Overview",
    ru: "Обзор",
    pl: "Przegląd",
  },
  activity_range: { en: "Range", ru: "Период", pl: "Zakres" },
  activity_active_days: { en: "Active days", ru: "Активных дней", pl: "Aktywne dni" },
  activity_avg_per_day: {
    en: "Avg / active day",
    ru: "В среднем за день",
    pl: "Średnio na dzień",
  },
  activity_best_day: { en: "Best day", ru: "Лучший день", pl: "Najlepszy dzień" },
  activity_total_heartbeats: {
    en: "Total heartbeats",
    ru: "Всего сигналов",
    pl: "Łącznie sygnałów",
  },
  activity_current_session: {
    en: "Current session",
    ru: "Текущая сессия",
    pl: "Bieżąca sesja",
  },
  activity_chart_window: {
    en: "Work window per day",
    ru: "Рабочее окно по дням",
    pl: "Przedział pracy dziennie",
  },
  activity_chart_heartbeats: {
    en: "Heartbeats per day",
    ru: "Сигналы по дням",
    pl: "Sygnały dziennie",
  },
  activity_chart_hourly: {
    en: "Requests by hour of day (total)",
    ru: "Запросы по часам суток (всего)",
    pl: "Żądania według godzin (łącznie)",
  },
  activity_peak_hour: { en: "Peak hour", ru: "Пиковый час", pl: "Godzina szczytu" },
  activity_accounts_title: {
    en: "Requests by account",
    ru: "Запросы по аккаунтам",
    pl: "Żądania według kont",
  },
  activity_accounts_empty: {
    en: "No per-account data for this range yet",
    ru: "Пока нет данных по аккаунтам за этот период",
    pl: "Brak danych według kont w tym zakresie",
  },
  activity_account_none: {
    en: "No account",
    ru: "Без аккаунта",
    pl: "Bez konta",
  },
  activity_requests: { en: "Requests", ru: "Запросы", pl: "Żądania" },
  activity_share: { en: "Share", ru: "Доля", pl: "Udział" },
  activity_daily_span: {
    en: "Daily work window",
    ru: "Рабочее окно по дням",
    pl: "Dzienny przedział pracy",
  },

  activity_team_analytics: {
    en: "Team analytics",
    ru: "Аналитика команды",
    pl: "Analiza zespołu",
  },
  activity_analytics_title: {
    en: "Operator analytics",
    ru: "Аналитика операторов",
    pl: "Analiza operatorów",
  },
  activity_team_total_requests: {
    en: "Total requests",
    ru: "Всего запросов",
    pl: "Łącznie żądań",
  },
  activity_avg_operator_day: {
    en: "Avg / operator / day",
    ru: "В среднем на оператора в день",
    pl: "Śr. na operatora dziennie",
  },
  activity_active_operators: {
    en: "Active operators",
    ru: "Активные операторы",
    pl: "Aktywni operatorzy",
  },
  activity_best_operator: {
    en: "Best operator",
    ru: "Лучший оператор",
    pl: "Najlepszy operator",
  },
  activity_requests_by_operator: {
    en: "Requests by operator",
    ru: "Запросы по операторам",
    pl: "Żądania według operatorów",
  },
  activity_rank: { en: "Rank", ru: "Место", pl: "Miejsce" },
  activity_effectiveness: {
    en: "Effectiveness",
    ru: "Эффективность",
    pl: "Efektywność",
  },
  activity_effectiveness_hint: {
    en: "vs team average",
    ru: "отн. среднего по команде",
    pl: "względem średniej zespołu",
  },
  activity_above_average: {
    en: "Above average",
    ru: "Выше среднего",
    pl: "Powyżej średniej",
  },
  activity_below_average: {
    en: "Below average",
    ru: "Ниже среднего",
    pl: "Poniżej średniej",
  },

  activity_generate_report: {
    en: "Generate report",
    ru: "Создать отчёт",
    pl: "Generuj raport",
  },
  activity_report_title: {
    en: "Worker activity report",
    ru: "Отчёт по активности сотрудников",
    pl: "Raport aktywności pracowników",
  },
  activity_report_hint: {
    en: "Detailed breakdown by operator. Click a column to rank by it; expand a row for hours by day.",
    ru: "Подробная разбивка по операторам. Нажмите на столбец, чтобы отсортировать; разверните строку, чтобы увидеть часы по дням.",
    pl: "Szczegółowy podział według operatora. Kliknij kolumnę, aby sortować; rozwiń wiersz, aby zobaczyć godziny według dni.",
  },
  activity_report_summary: { en: "Summary", ru: "Итоги", pl: "Podsumowanie" },
  activity_report_period: { en: "Period", ru: "Период", pl: "Okres" },
  activity_report_generated: { en: "Generated", ru: "Создано", pl: "Wygenerowano" },
  activity_total_operators: { en: "Operators", ru: "Операторы", pl: "Operatorzy" },
  activity_total_hours: {
    en: "Total hours online",
    ru: "Всего часов онлайн",
    pl: "Łączne godziny online",
  },
  activity_avg_hours_day: {
    en: "Avg hours / day",
    ru: "Сред. часов / день",
    pl: "Śr. godziny / dzień",
  },
  activity_avg_hours_operator_day: {
    en: "Avg hours / operator / day",
    ru: "Сред. часов / оператор / день",
    pl: "Śr. godziny / operator / dzień",
  },
  activity_hours: { en: "Hours", ru: "Часы", pl: "Godziny" },
  activity_hours_by_day: { en: "Hours by day", ru: "Часы по дням", pl: "Godziny według dni" },
  activity_download_pdf: { en: "Download PDF", ru: "Скачать PDF", pl: "Pobierz PDF" },
  activity_no_days: {
    en: "No activity in this period",
    ru: "Нет активности за период",
    pl: "Brak aktywności w tym okresie",
  },

  doc_completed: { en: "Completed", ru: "Готово", pl: "Gotowe" },

  doc_reisepass: { en: "Reisepass", ru: "Загранпаспорт", pl: "Paszport (Reisepass)" },
  doc_aufenthaltstitel: {
    en: "Aufenthaltstitel",
    ru: "Вид на жительство",
    pl: "Pozwolenie na pobyt (Aufenthaltstitel)",
  },
  doc_meldebestaetigung: {
    en: "Meldebestätigung",
    ru: "Регистрация",
    pl: "Zaświadczenie o zameldowaniu (Meldebestätigung)",
  },
  doc_wbs: { en: "WBS", ru: "WBS", pl: "WBS" },
  doc_dringlichkeitsbestaetigung: {
    en: "Dringlichkeitsbestätigung",
    ru: "Подтверждение срочности",
    pl: "Zaświadczenie o pilności (Dringlichkeitsbestätigung)",
  },
  doc_jobcenter_bescheid: {
    en: "Jobcenter Bescheid",
    ru: "Решение Jobcenter",
    pl: "Decyzja Jobcenter (Bescheid)",
  },
  doc_arbeitsvertrag: {
    en: "Arbeitsvertrag",
    ru: "Трудовой договор",
    pl: "Umowa o pracę (Arbeitsvertrag)",
  },
  doc_kontoauszuege: {
    en: "Kontoauszüge (3 Monate)",
    ru: "Выписки со счёта (3 мес.)",
    pl: "Wyciągi bankowe (3 mies.)",
  },
  doc_korrespondenz_jobcenter: {
    en: "Korrespondenz Jobcenter",
    ru: "Переписка с Jobcenter",
    pl: "Korespondencja z Jobcenter",
  },
  doc_korrespondenz_sozialamt: {
    en: "Korrespondenz Sozialamt",
    ru: "Переписка с Sozialamt",
    pl: "Korespondencja z Sozialamt",
  },
  doc_korrespondenz_fachstelle: {
    en: "Korrespondenz Fachstelle",
    ru: "Переписка с Fachstelle",
    pl: "Korespondencja z Fachstelle",
  },
  doc_korrespondenz_vermieter: {
    en: "Korrespondenz Vermieter",
    ru: "Переписка с арендодателем",
    pl: "Korespondencja z wynajmującym",
  },
  doc_wohnungen_bewerbungen: {
    en: "Wohnungen Bewerbungen/Absagen",
    ru: "Заявки/отказы на жильё",
    pl: "Podania/odmowy dotyczące mieszkań",
  },
  doc_sonstige_wohnunterlagen: {
    en: "Sonstige Wohnunterlagen",
    ru: "Прочие документы по жилью",
    pl: "Inne dokumenty mieszkaniowe",
  },
  docs_all_uploaded: { en: "All uploaded", ru: "Все загружены", pl: "Wszystko przesłane" },

  mail_m2: { en: "G2", ru: "G2", pl: "G2" },
  mail_m3: { en: "M3", ru: "M3", pl: "M3" },
  mail_m4: { en: "F4", ru: "F4", pl: "F4" },
  mail_m5: { en: "R5", ru: "R5", pl: "R5" },
  mail_m6: { en: "T6", ru: "T6", pl: "T6" },

  mail_type_gratitude: { en: "Gratitude", ru: "Благодарность", pl: "Podziękowanie" },
  mail_type_motivation: { en: "Motivation", ru: "Мотивация", pl: "Motywacja" },
  mail_type_feedback: { en: "Feedback", ru: "Отзыв", pl: "Opinia" },
  mail_type_after_review: { en: "After Review", ru: "После осмотра", pl: "Po oglądaniu" },
  mail_type_termin: { en: "Termin", ru: "Термин", pl: "Termin" },

  log_action_add: { en: "ADD", ru: "ДОБАВЛЕНИЕ", pl: "DODANIE" },
  log_action_edit: { en: "EDIT", ru: "РЕДАКТИРОВАНИЕ", pl: "EDYCJA" },
  log_action_queued: { en: "QUEUED", ru: "В ОЧЕРЕДИ", pl: "W KOLEJCE" },

  log_mode_clients: { en: "Clients", ru: "Клиенты", pl: "Klienci" },
  log_mode_system: { en: "System", ru: "Система", pl: "System" },

  tip_open_link: { en: "Open link", ru: "Открыть ссылку", pl: "Otwórz link" },
  tip_edit: { en: "Edit", ru: "Редактировать", pl: "Edytuj" },
  tip_comment: { en: "Comment", ru: "Комментарий", pl: "Komentarz" },
  dialog_client_comment: {
    en: "Client Comment",
    ru: "Комментарий клиента",
    pl: "Komentarz klienta",
  },
  tip_archive: { en: "Archive", ru: "Архивировать", pl: "Archiwizuj" },
  tip_archive_disabled: {
    en: "Can only archive completed, denied, absage, or no relevant records",
    ru: "Архивировать можно только завершённые, отклонённые, отказ или не актуальные записи",
    pl: "Archiwizować można tylko rekordy zakończone, odrzucone, odmowa lub nieaktualne",
  },

  toast_copied: {
    en: "URL copied to clipboard",
    ru: "URL скопирован",
    pl: "URL skopiowany do schowka",
  },
  toast_archive_not_allowed: {
    en: "Record cannot be archived with current status",
    ru: "Запись нельзя архивировать с текущим статусом",
    pl: "Nie można zarchiwizować rekordu przy obecnym statusie",
  },

  filter_all: { en: "All", ru: "Все", pl: "Wszystkie" },
  filter_all_accounts: { en: "All accounts", ru: "Все аккаунты", pl: "Wszystkie konta" },
  filter_all_clients: { en: "All clients", ru: "Все клиенты", pl: "Wszyscy klienci" },
  filter_my_clients: { en: "My clients", ru: "Мои клиенты", pl: "Moji klienci" },
  filter_all_users: { en: "All users", ru: "Все пользователи", pl: "Wszyscy użytkownicy" },
  filter_all_operators: {
    en: "All operators",
    ru: "Все операторы",
    pl: "Wszyscy operatorzy",
  },
  filter_duplicates_only: { en: "Duplicates only", ru: "Только дубликаты", pl: "Tylko duplikaty" },
  label_duplicate: { en: "Duplicate", ru: "Дубль", pl: "Duplikat" },
  duplicates_count: { en: "{n} duplicate records", ru: "{n} дублей", pl: "{n} duplikatów" },

  btn_download_pdf: { en: "Download PDF", ru: "Скачати PDF", pl: "Pobierz PDF" },
  btn_clear_logs: { en: "Clear Logs", ru: "Очистити логи", pl: "Wyczyść logi" },
  dialog_clear_logs: { en: "Clear Logs", ru: "Очистити логи", pl: "Wyczyść logi" },
  clear_logs_select_client: {
    en: "Select which client's logs to clear",
    ru: "Оберіть клієнта для очищення логів",
    pl: "Wybierz klienta, którego logi wyczyścić",
  },
  clear_logs_all: { en: "All clients", ru: "Усі клієнти", pl: "Wszyscy klienci" },
  clear_logs_count: {
    en: "{n} log entries will be deleted",
    ru: "{n} записів логів буде видалено",
    pl: "{n} wpisów logów zostanie usuniętych",
  },
  toast_logs_cleared: {
    en: "{n} logs deleted",
    ru: "{n} логів видалено",
    pl: "Usunięto {n} logów",
  },
  btn_send_report: {
    en: "Send report to Telegram",
    ru: "Надіслати звіт у Telegram",
    pl: "Wyślij raport do Telegrama",
  },
  dialog_send_report: {
    en: "Send Report to Telegram",
    ru: "Надіслати звіт у Telegram",
    pl: "Wyślij raport do Telegrama",
  },
  report_sending: {
    en: "Sending...",
    ru: "Надсилання...",
    pl: "Wysyłanie...",
  },
  report_select_client: {
    en: "Select a client first",
    ru: "Спочатку виберіть клієнта",
    pl: "Najpierw wybierz klienta",
  },
  report_sent: {
    en: "Report sent to chat {chat} ({records} records)",
    ru: "Звіт надіслано в чат {chat} ({records} записів)",
    pl: "Raport wysłano do czatu {chat} ({records} wpisów)",
  },
  btn_duplicates: { en: "Duplicates", ru: "Дублікати", pl: "Duplikaty" },
  dialog_duplicates: {
    en: "Duplicate Detection",
    ru: "Виявлення дублікатів",
    pl: "Wykrywanie duplikatów",
  },
  duplicates_loading: {
    en: "Checking duplicates...",
    ru: "Перевірка дублікатів...",
    pl: "Sprawdzanie duplikatów...",
  },
  duplicates_total: {
    en: "{n} duplicate records found",
    ru: "Знайдено {n} дублікатів",
    pl: "Znaleziono {n} duplikatów",
  },
  duplicates_none: {
    en: "No duplicates found",
    ru: "Дублікатів не знайдено",
    pl: "Nie znaleziono duplikatów",
  },
  toast_duplicates_removed: {
    en: "{n} duplicates removed",
    ru: "Видалено {n} дублікатів",
    pl: "Usunięto {n} duplikatów",
  },
  duplicates_removing: {
    en: "Removing...",
    ru: "Видалення...",
    pl: "Usuwanie...",
  },
  btn_delete_duplicates: {
    en: "Delete duplicates",
    ru: "Видалити дублікати",
    pl: "Usuń duplikaty",
  },
  dialog_delete_duplicates: {
    en: "Delete Duplicate Records",
    ru: "Видалити дубльовані записи",
    pl: "Usuń zdublowane rekordy",
  },
  duplicates_groups_count: {
    en: "{n} duplicate groups found",
    ru: "Знайдено {n} груп дублікатів",
    pl: "Znaleziono {n} grup duplikatów",
  },
  duplicates_delete_count: {
    en: "{n} records will be deleted — one record is kept in each group",
    ru: "Буде видалено {n} записів — у кожній групі залишиться один запис",
    pl: "Zostanie usuniętych {n} rekordów — w każdej grupie zostanie jeden rekord",
  },
  duplicates_keep_rule: {
    en: "The most complete record is kept in each group: most sent mails, furthest status, older record wins ties.",
    ru: "У кожній групі зберігається найбільш повний запис: найбільше листів, найдаліший статус, при рівності — старіший запис.",
    pl: "W każdej grupie zostaje najbardziej kompletny rekord: najwięcej wysłanych maili, dalszy status, przy remisie — starszy rekord.",
  },
  duplicates_type_confirm: {
    en: "Type “delete duplicates” to confirm",
    ru: "Введіть “delete duplicates”, щоб підтвердити",
    pl: "Wpisz “delete duplicates”, aby potwierdzić",
  },
  toast_duplicates_failed: {
    en: "{n} records could not be deleted",
    ru: "Не вдалося видалити {n} записів",
    pl: "Nie udało się usunąć {n} rekordów",
  },
  th_group_size: { en: "Group", ru: "Група", pl: "Grupa" },
  th_will_delete: { en: "To delete", ru: "До видалення", pl: "Do usunięcia" },
  log_pdf_title: { en: "Logs Report", ru: "Отчёт по логам", pl: "Raport logów" },
  pdf_select_fields: {
    en: "Select which fields to include in the PDF:",
    ru: "Оберіть поля для PDF:",
    pl: "Wybierz pola do uwzględnienia w PDF:",
  },
  pdf_preview_more: { en: " more entries", ru: " більше записів", pl: " więcej wpisów" },

  empty_no_results: { en: "No results found", ru: "Ничего не найдено", pl: "Brak wyników" },
  empty_no_logs: { en: "No logs found", ru: "Логи не найдены", pl: "Nie znaleziono logów" },
  empty_no_dumps: { en: "No dumps found", ru: "Дампы не найдены", pl: "Nie znaleziono dumpów" },

  search_dumps: { en: "Search dumps...", ru: "Поиск дампов...", pl: "Szukaj dumpów..." },

  th_filename: { en: "Filename", ru: "Имя файла", pl: "Nazwa pliku" },
  th_file_size: { en: "Size", ru: "Размер", pl: "Rozmiar" },
  th_duration: { en: "Duration", ru: "Длительность", pl: "Czas trwania" },
  th_dump_status: { en: "Status", ru: "Статус", pl: "Status" },
  th_error: { en: "Error", ru: "Ошибка", pl: "Błąd" },

  dump_status_success: { en: "SUCCESS", ru: "УСПЕШНО", pl: "SUKCES" },
  dump_status_failed: { en: "FAILED", ru: "ОШИБКА", pl: "BŁĄD" },

  btn_delete_dump: { en: "Delete", ru: "Удалить", pl: "Usuń" },
  dialog_delete_dump: { en: "Delete Dump", ru: "Удалить дамп", pl: "Usuń dump" },
  dialog_delete_dump_confirm: {
    en: "Are you sure you want to delete this dump file?",
    ru: "Вы уверены, что хотите удалить этот файл дампа?",
    pl: "Czy na pewno chcesz usunąć ten plik dumpu?",
  },
  toast_dump_deleted: { en: "Dump deleted", ru: "Дамп удалён", pl: "Dump usunięty" },

  dialog_delete_record: { en: "Delete Record", ru: "Удалить запись", pl: "Usuń rekord" },
  dialog_delete_confirm: {
    en: "Are you sure you want to delete this record?",
    ru: "Вы уверены, что хотите удалить эту запись?",
    pl: "Czy na pewno chcesz usunąć ten rekord?",
  },
  btn_yes: { en: "Yes", ru: "Да", pl: "Tak" },
  btn_no: { en: "No", ru: "Нет", pl: "Nie" },

  th_mail_content: { en: "Mail Content", ru: "Содержание письма", pl: "Treść e-maila" },
  th_german: { en: "German", ru: "Немецкий", pl: "Niemiecki" },
  th_ukrainian: { en: "Ukrainian", ru: "Украинский", pl: "Ukraiński" },
  btn_copy_german: { en: "Copy German", ru: "Копировать DE", pl: "Kopiuj DE" },
  btn_copy_ukrainian: { en: "Copy Ukrainian", ru: "Копировать UA", pl: "Kopiuj UA" },
  btn_view_content: { en: "Content", ru: "Контент", pl: "Treść" },

  th_source: { en: "Source", ru: "Источник", pl: "Źródło" },
  label_immomio: { en: "Immomio", ru: "Immomio", pl: "Immomio" },
  label_manual: { en: "Manual", ru: "Вручную", pl: "Ręcznie" },
  label_auto: { en: "Auto", ru: "Авто", pl: "Auto" },
  form_source: { en: "Source", ru: "Источник", pl: "Źródło" },

  th_name: { en: "Name", ru: "Имя", pl: "Imię" },
  th_last_online: { en: "Last Online", ru: "Последний раз онлайн", pl: "Ostatnio online" },

  status_online: { en: "Online", ru: "Онлайн", pl: "Online" },
  status_idle: { en: "Idle", ru: "Отсутствует", pl: "Bezczynny" },
  status_offline: { en: "Offline", ru: "Не в сети", pl: "Offline" },

  operators_online_count: {
    en: "{n} currently online",
    ru: "{n} сейчас онлайн",
    pl: "{n} obecnie online",
  },

  sub_3m: { en: "3 months", ru: "3 месяца", pl: "3 miesiące" },
  sub_6m: { en: "6 months", ru: "6 месяцев", pl: "6 miesięcy" },
  sub_1y: { en: "1 year", ru: "год", pl: "1 rok" },
  sub_premium: { en: "Premium", ru: "Премиум", pl: "Premium" },

  error_url: {
    en: "Object Link must be a valid URL (http:// or https://)",
    ru: "Ссылка должна быть валидным URL (http:// или https://)",
    pl: "Link do obiektu musi być prawidłowym adresem URL (http:// lub https://)",
  },

  nav_profiles: { en: "Profiles", ru: "Профили", pl: "Profile" },
  nav_listings: { en: "Listings", ru: "Объявления", pl: "Ogłoszenia" },
  nav_jobs: { en: "Jobs", ru: "Задачи", pl: "Zadania" },
  nav_matching: { en: "Matching", ru: "Подбор", pl: "Dopasowania" },

  th_profile_name: { en: "Name", ru: "Имя", pl: "Nazwa" },
  th_max_rent: { en: "Max Rent", ru: "Макс. аренда", pl: "Maks. czynsz" },
  th_rooms_range: { en: "Rooms", ru: "Комнаты", pl: "Pokoje" },
  th_size_range: { en: "Size", ru: "Площадь", pl: "Powierzchnia" },
  th_family_size: { en: "Family", ru: "Семья", pl: "Rodzina" },
  th_active: { en: "Active", ru: "Активен", pl: "Aktywny" },
  th_matches: { en: "Matches", ru: "Совпадения", pl: "Dopasowania" },
  th_desire_location: { en: "Excellent", ru: "Отлично", pl: "Doskonała" },
  th_good_location: { en: "Good", ru: "Хорошо", pl: "Dobra" },
  th_optimally_location: { en: "Optimally", ru: "Оптимально", pl: "Optymalna" },

  form_profile_name: { en: "Profile Name", ru: "Имя профиля", pl: "Nazwa profilu" },
  form_max_rent: { en: "Max Rent (€)", ru: "Макс. аренда (€)", pl: "Maks. czynsz (€)" },
  form_min_rooms: { en: "Min Rooms", ru: "Мин. комнат", pl: "Min. pokoi" },
  form_max_rooms: { en: "Max Rooms", ru: "Макс. комнат", pl: "Maks. pokoi" },
  form_min_size: { en: "Min Size (m²)", ru: "Мин. площадь (м²)", pl: "Min. powierzchnia (m²)" },
  form_max_size: { en: "Max Size (m²)", ru: "Макс. площадь (м²)", pl: "Maks. powierzchnia (m²)" },
  form_family_size: { en: "Family Size", ru: "Размер семьи", pl: "Wielkość rodziny" },

  th_application_link: { en: "Apply Link", ru: "Ссылка подачи", pl: "Link do zgłoszenia" },
  th_listing_status: { en: "Status", ru: "Статус", pl: "Status" },
  th_listing_created: { en: "Received", ru: "Получено", pl: "Otrzymano" },

  listing_status_new: { en: "New", ru: "Новое", pl: "Nowe" },
  listing_status_matched: { en: "Matched", ru: "Сопоставлено", pl: "Dopasowane" },
  listing_status_processed: { en: "Processed", ru: "Обработано", pl: "Przetworzone" },
  listing_status_skipped: { en: "Skipped", ru: "Пропущено", pl: "Pominięte" },

  job_status_pending: { en: "Pending", ru: "Ожидает", pl: "Oczekuje" },
  job_status_claimed: { en: "Claimed", ru: "В работе", pl: "W pracy" },
  job_status_completed: { en: "Completed", ru: "Выполнено", pl: "Ukończono" },
  job_status_failed: { en: "Failed", ru: "Ошибка", pl: "Niepowodzenie" },

  th_job_type: { en: "Type", ru: "Тип", pl: "Typ" },
  th_worker: { en: "Worker", ru: "Воркер", pl: "Worker" },
  th_claimed_at: { en: "Claimed", ru: "Взято", pl: "Pobrane" },
  th_completed_at: { en: "Completed", ru: "Завершено", pl: "Ukończono" },
  th_retries: { en: "Retries", ru: "Повторы", pl: "Ponowienia" },

  filter_all_sources: { en: "All sources", ru: "Все источники", pl: "Wszystkie źródła" },
  filter_all_statuses: { en: "All statuses", ru: "Все статусы", pl: "Wszystkie statusy" },

  dialog_add_profile: { en: "Add Profile", ru: "Добавить профиль", pl: "Dodaj profil" },
  dialog_edit_profile: { en: "Edit Profile", ru: "Редактировать профиль", pl: "Edytuj profil" },

  nav_gmail: { en: "Gmail", ru: "Gmail", pl: "Gmail" },

  gmail_connected: { en: "Mailboxes", ru: "Почтовых ящиков", pl: "Skrzynki pocztowe" },
  gmail_new_today: { en: "New today", ru: "Новых сегодня", pl: "Nowe dzisiaj" },
  gmail_unread: { en: "Unread", ru: "Непрочитано", pl: "Nieprzeczytane" },
  gmail_gmail: { en: "Gmail", ru: "Gmail", pl: "Gmail" },
  gmail_outlook: { en: "Outlook", ru: "Outlook", pl: "Outlook" },
  gmail_search: { en: "Search mails...", ru: "Поиск писем...", pl: "Szukaj e-maili..." },
  gmail_all_providers: { en: "All providers", ru: "Все провайдеры", pl: "Wszyscy dostawcy" },
  gmail_all_statuses: { en: "All statuses", ru: "Все статусы", pl: "Wszystkie statusy" },
  gmail_read: { en: "Read", ru: "Прочитано", pl: "Przeczytane" },
  gmail_sync: { en: "Sync now", ru: "Синхронизировать", pl: "Synchronizuj teraz" },
  gmail_syncing: { en: "Syncing...", ru: "Синхронизация...", pl: "Synchronizacja..." },
  gmail_last_sync: {
    en: "Last sync",
    ru: "Последняя синхронизация",
    pl: "Ostatnia synchronizacja",
  },
  gmail_mark_all_read: {
    en: "Mark all read",
    ru: "Отметить прочитанным",
    pl: "Oznacz wszystkie jako przeczytane",
  },
  gmail_empty: {
    en: "No mails match the filters",
    ru: "Нет писем по заданным фильтрам",
    pl: "Brak e-maili spełniających filtry",
  },
  gmail_loading: { en: "Parsing mails...", ru: "Разбор писем...", pl: "Analizowanie e-maili..." },
  th_mailbox: { en: "Mailbox", ru: "Почтовый ящик", pl: "Skrzynka pocztowa" },
  th_provider: { en: "Provider", ru: "Провайдер", pl: "Dostawca" },
  th_from: { en: "From", ru: "Отправитель", pl: "Od" },
  th_subject: { en: "Subject", ru: "Тема", pl: "Temat" },
  th_received: { en: "Received", ru: "Получено", pl: "Otrzymano" },
} as const

export type TranslationKey = keyof typeof translations
